module.exports = __webpack_public_path__ + "static/media/fs.464f544a.gif";